import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) {
      // don't scroll to top if the url has a hash inside it (e.g. in the FAQScreen I use hashed so that the user can jump to a specific FAQ via a URL. In this case the user should be scrolled to the FAQ and not the top of the screen)
      window.scrollTo(0, 0);
    }
  }, [location]);

  return null;
};

export default ScrollToTop;
